import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';

export const usePathMatch = childRoute => {
	const [params, setParams] = useState(null);

	useEffect(() => {
		const { params } = matchPath(childRoute, {
			path: '/:base/:routeName?/:navRouteName?/:id?',
			exact: false,
			strict: false
		}) || { params: { base: '', routeName: '', navRouteName: '' } };
		setParams(params);
	}, [childRoute]);

	return params;
};
export const useRedirect = ({ childRoute, from, to }, matchParams) => {
	const history = useHistory();
	const location = useLocation();
	useEffect(() => {
		if (location.pathname === from) {
			history.push(to);
		}
	}, [childRoute]);
};
